import * as Yup from "yup";

export default Yup.object({
    ownerId: Yup.mixed().required("Please select an owner"),
    deviceSerialNumber: Yup.string().required("Please enter device serial number"),
});

